export default __webpack_public_path__ + "arrow.b4daee78.svg";